
import EditTeamProfile from 'marketplace/team-profile/_views/edit-team-profile';
import ViewTeamProfile from 'marketplace/team-profile/_views/view-team-profile';
import EditCompanyProfile from 'marketplace/companies/profiles/_views/edit-company-profile';
import ViewCompanyProfile from 'marketplace/companies/profiles/_views/view-company-profile';
import EditIndividualProfile from 'marketplace/individuals/profiles/_views/forms/edit/edit-individual-profile-form';
import ViewIndividualProfile from 'marketplace/individuals/profiles/_views/individual-profile-container';
import { PageTab } from './profiles-page-tabs';

/** @description A map of avatar IDs to base64 encoded image data strings */
export type AvatarMap = { [avatarId: string]: string };

export const editComponentMap = {
  [PageTab.Company]: EditCompanyProfile,
  [PageTab.Teams]: EditTeamProfile,
  [PageTab.Individual]: EditIndividualProfile
};

export const viewComponentMap = {
  [PageTab.Company]: ViewCompanyProfile,
  [PageTab.Teams]: ViewTeamProfile,
  [PageTab.Individual]: ViewIndividualProfile
};
